import Vuex from 'vuex';
import Vue from 'vue';
import { FAQ_NAMESPACE, faq } from './modules/faq/faq.store.js';
import { CONSENTS_NAMESPACE, consent } from './modules/consents/consents.store.js';
import { OFFER_NAMESPACE, offers } from './modules/offer/offer.store.js';
import { STATIC_PAGES_NAMESPACE, staticPage } from './modules/static-pages/static-pages.store.js';
import { PROMOTIONS_NAMESPACE, promotions } from './modules/promotions/promotions.store.js';

Vue.use(Vuex);
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    [FAQ_NAMESPACE]: faq,
    [CONSENTS_NAMESPACE]: consent,
    [OFFER_NAMESPACE]: offers,
    [STATIC_PAGES_NAMESPACE]: staticPage,
    [PROMOTIONS_NAMESPACE]: promotions
  }
});

export { store };
